import React from 'react'
import styled from 'styled-components'
import { bool, func } from 'prop-types'
import Button from '@taglivros/oef_componentes/build/components/button'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Modal from '@taglivros/oef_componentes/build/components/modal'

import { SOLICITACAO_DESFEITA_TITULO, SOLICITACAO_DESFEITA_BOTAO, SOLICITACAO_DESFEITA_DESCRICAO } from '../../constantsCancelarAssinatura'

const ModalWrapper = styled.div`
  display: block;
  text-align: center;

  .wrapper__button__modal {
    align-items: center;
    margin: 30px auto 20px;
    color: ${StyleGuide.cores.branco};

    @media( max-width: ${StyleGuide.mediaQuery.mobile} ) {
      margin: 30px auto 0px;
    }
  }

  h3 {
    color: ${StyleGuide.cores.azul};
    ${StyleGuide.boldFonte};
    margin: 20px 0;
  }

  .descricao__modal {
    margin: 10px auto 0;
    max-width: 60%;

    @media( max-width: ${StyleGuide.mediaQuery.mobile} ) {
      max-width: 100%;
    }
  }
`

const ModalCancelarSolicitacao = ( { onShowModal, show, onClickBotao } ) => {
  return (
    <Modal
      altura="auto"
      largura="465px"
      onShowModal={ onShowModal }
      show={ show }
    >
      <ModalWrapper>
        <h3>
          { SOLICITACAO_DESFEITA_TITULO }
        </h3>

        <p className="descricao__modal">
          { SOLICITACAO_DESFEITA_DESCRICAO }
        </p>

        <div className="wrapper__button__modal">
          <Button
            onClick={ onClickBotao }
            tema={ Button.BOTAO_CURADORIA }
          >
            { SOLICITACAO_DESFEITA_BOTAO }
          </Button>
        </div>
      </ModalWrapper>
    </Modal>
  )
}

ModalCancelarSolicitacao.defaultProps = {
  'onClickBotao': null,
  'onShowModal': null,
  'show': true
}

ModalCancelarSolicitacao.propTypes = {
  'onClickBotao': func,
  'onShowModal': func,
  'show': bool
}

export default ModalCancelarSolicitacao
